import { createElement, ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { TranslatedComponent, translation } from 'frontStaticAppPath/lib';

import { Snackbar } from '@hh.ru/magritte-ui';
import { MinusCircleFilledSize24, CheckCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import Debug from 'bloko/common/core/Debug';

import { removeNotificationByIdAction } from 'src/models/notifications';
import { useSelector } from 'src/modules/useSelector';

import { NotificationKind } from 'src/components/Notifications/types';
import variants from 'src/components/Notifications/variants';

const notificationAddons: Record<NotificationKind, ReactElement> = {
    ok: createElement(CheckCircleFilledSize24, { initialColor: 'positive' }),
    error: createElement(MinusCircleFilledSize24, { initialColor: 'negative' }),
};

const Notifications: TranslatedComponent = () => {
    const dispatch = useDispatch();
    const notifications = useSelector((state) => state.notifications);
    return (
        <>
            {notifications.map(({ type, id, props }) => {
                if (!variants[type] || (typeof variants[type] === 'object' && !variants[type].Element)) {
                    Debug.log('out error', new Error(`Notification ${type} is not defined`));
                    return null;
                }

                const { Element, onClose, ...notificationProps } = variants[type];

                return (
                    <Snackbar
                        addon={notificationAddons[notificationProps.kind]}
                        key={id}
                        autohideTime={notificationProps.autoClose ? 6000 : 0}
                        showClose={!notificationProps.hideClose}
                        showTimer={false}
                        actionLabel={notificationProps.label}
                        onClose={() => {
                            onClose?.();
                            dispatch(removeNotificationByIdAction(id));
                        }}
                    >
                        <Element {...props} />
                    </Snackbar>
                );
            })}
        </>
    );
};

export default translation(Notifications);
